import styled, { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const ModalHeaderLabel = styled.div<IWithSize>`
  font-weight: 600;
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;
  color: ${(props: ITheme) => props.theme.colors.palette.slateGrey};
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export default ModalHeaderLabel
